/* @flow */
import * as React from 'react';

function BonusesAndPenalties(): React.Node {
  // TODO: Implement Bonuses And Penalties page
  return <div>Bonuses And Penalties</div>;
}

export default BonusesAndPenalties;
